export const HEADER = 'Trigger Import';
export const ARE_YOU_SURE_TEXT =
  'Are you sure you want to continue with this import?';
export const CHANGES_REFLECTED_TEXT =
  'Changes made are irreversible and may affect many records.';
export const CANCEL_TEXT = 'Cancel';
export const CONTINUE_TEXT = 'Continue';
